import React from 'react'
import { Outlet } from 'react-router-dom'

import ConfigListPage from './pages/ConfigListPage'
import ConfigEditPage from './pages/ConfigEditPage'

export const routes = {
  admin: [
    {
      path: 'config',
      label: 'Configurações',
      element: <Outlet />,
      children: [
        { path: '', element: <ConfigListPage /> },
        {
          path: ':configId',
          label: ({ configId }) => `Editar configuração #${configId}`,
          element: <ConfigEditPage />
        }
      ]
    }
  ]
}

export default routes
